import {DatasetSource} from './datasets/dataset-source';
import {CodeDescription} from './code-description';

export interface GovernmentType extends CodeDescription {
	count: number;
	activeCount: number;
	inactiveCount: number;
	isLocalGovernment: boolean;
	//canHaveFinancials: boolean;  // This property is obsolete. Use financialsDataset instead.
	canHaveIndicators: boolean;
	financialsDatasetSource: DatasetSource;
	treasurers: Array<GenericCountType>;
	componentUnits: Array<GenericCountType>;
	governingBodyTypes: Array<GenericCountType>;
	governingBodyOrigins: Array<GenericCountType>;
	accountingBases: Array<GenericCountType>;
	detailDescription: string;
	shortDescription: string;
	acronym: string;
}

export interface GenericCountType {
	id: string;
	name: string;
	number: number;
	activeCount: number;
	inactiveCount: number;
}

export const ALL_GOVT_TYPES: ALL_GOVT_TYPES = 'All types';
export type ALL_GOVT_TYPES = 'All types';

